import { Injectable } from '@angular/core';
import { Spreading } from '../interfaces/spreading';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpreadingCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/spreadings/current/' ;
  }

  getOrganisation() : string | null {
    const company = JSON.parse(localStorage.getItem('company')!);
    if (company && typeof company.$key !== 'undefined') {
        return company.$key;
    }
    return null;
  }

  // newPath() {
  //   const user = JSON.parse(localStorage.getItem('user')!)
  //   const company = JSON.parse(localStorage.getItem('company')!);
  //   this.path = 'users' + '/' + user.uid + '/' + 'companies' + '/' + company.$key + '/' + 'barrels/currentBarrels/';
  // }

  // Create Barrel
  add(record: Spreading) {
    const org = this.getOrganisation();
    if (!org) {
      return;
    } 
    this.refs = this.db.list( 'organisations/' + org + '/' + this.path );
    const item = {
      ...record
    }
    console.log(item);
    const newItem = this.refs?.push( item );
    const key = newItem.key;
    item.key = key || 'na';
    item.$key = key || 'na';
    this.update(item);
  }
  // Fetch Single Barrel Object
  get(id: string) {
    const org = this.getOrganisation();
    if (!org) {
      return {} as AngularFireObject<any>;
    }  
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + id);
    return this.ref;
  }
  // Fetch Barrels List
  getList() {
    const org = this.getOrganisation();
    if (!org) {
      return {} as AngularFireList<any>;
    } 
    this.refs = this.db.list( 'organisations/' + org + '/' + this.path );
    return this.refs;
  }
  // Update Barrel Object
  update(record: Spreading) {
    const org = this.getOrganisation();
    if (!org) {
      return;
    } 
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + record.$key);
    let item : Partial<Spreading>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Barrel Object
  delete(id: string) {
    const org = this.getOrganisation();
    if (!org) {
      return;
    } 
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + id);
    this.ref.remove();
  }
}